export default __webpack_public_path__ + "static/media/cross.bf18d58a.svg";